/**
 * Sending damaged purchased goods back to the vendor (t1154), and the credit
 * the vendor gives for them. Separate from `purchase_orders` (what is still
 * on order) and from customer returns in `order-states.ts` (goods coming back
 * from a sale).
 *
 * needs_return -> shipped -> received_by_vendor -> credited, with `cancelled`
 * available only before it ships (the goods are put back where they came from).
 */
export const VENDOR_RETURN_STATUSES = [
    'needs_return',
    'shipped',
    'received_by_vendor',
    'credited',
    'cancelled',
];
export const VENDOR_RETURN_TRANSITIONS = {
    needs_return: ['shipped', 'cancelled'],
    shipped: ['received_by_vendor'],
    received_by_vendor: ['credited'],
    credited: [],
    cancelled: [],
};
export function canTransitionVendorReturn(from, to) {
    return VENDOR_RETURN_TRANSITIONS[from].includes(to);
}
/** Still moving through the process — the goods are out of stock and unresolved. */
export const OPEN_VENDOR_RETURN_STATUSES = [
    'needs_return',
    'shipped',
    'received_by_vendor',
];
/**
 * What the vendor did once they confirmed: `account_credit` is kept as a
 * balance on the vendor's account (usable on a later invoice); `refund` is
 * money that came straight back, so nothing is added to the balance.
 */
export const VENDOR_RETURN_OUTCOMES = ['account_credit', 'refund'];
/** `return_credit` adds to the balance, `applied` spends it on an invoice, `adjust` is a staff correction. */
export const VENDOR_CREDIT_TXN_KINDS = ['return_credit', 'applied', 'adjust'];
//# sourceMappingURL=vendor-returns.js.map